import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10.4998 13.0002c.276 0 .5.224.5.5v5c0 .276-.224.5-.5.5-.275 0-.5-.224-.5-.5v-3.793l-5.146 5.146a.4957.4957 0 01-.354.147.498.498 0 01-.354-.146.5003.5003 0 010-.707l5.146-5.147h-3.793c-.275 0-.5-.224-.5-.5s.225-.5.5-.5h5.001zm8.6455-8.854a.5003.5003 0 01.707 0c.195.195.195.512 0 .707l-5.146 5.146h3.792c.277 0 .5.224.5.5s-.223.5-.5.5h-5c-.275 0-.5-.224-.5-.5v-5c0-.276.225-.5.5-.5.277 0 .5.224.5.5v3.793l5.147-5.146z',
  ],
  height: 24,
  width: 24,
});
